<ix-input
  (valueChange)="onPassportSearchInputChange($event)"
  (focus)="onInputFocus()"
  (blur)="onInputBlur()"
  [class.ix-invalid]="!!invalidText"
  [disabled]="disabled"
  [invalidText]="invalidText"
  [label]="label"
  [value]="value"
  [id]="inputId"
  [placeholder]="'battery_pass.search_select.helper_text' | translate"
  class="w-100 mt-2"
  type="text">
  <ix-icon name="chevron-down" size='16' slot="end"></ix-icon>
  @if (!loading) {
    <ix-icon name="search" size='16' slot="start"></ix-icon>
  }
  @if (loading) {
    <ix-spinner size="x-small" slot="start"></ix-spinner>
  }
</ix-input>
<ix-dropdown
  [show]="dropdownVisible()"
  [closeBehavior]="false"
  [anchor]="inputId"
  class="dropdown">
  @if (filteredPassports.length > 0 ) {
    @for (passport of filteredPassports; track passport.id) {
      <ix-dropdown-item
        (click)="onPassportSelect(passport)"
        [disabled]="loading"
        [label]="passport.metadata.name ?? passport.id"
        onkeypress=""
        checked="false">
      </ix-dropdown-item>
    }
  } @else {
    <ix-dropdown-header
    [label]="'battery_pass.hierarchy.no_results' | translate"></ix-dropdown-header>
  }
</ix-dropdown>
